<div class="w-[1200px]" *tuiLet="loadingDetails$ | async as loadingDetails">
  <h2 class="font-semibold mb-4 text-lg">Загрузить файл</h2>
  <div class="flex gap-x-2 mb-2">
    <div class="w-3/12">
      <app-autocomplete
        label="Код покупателя"
        [strict]="false"
        [labelOutside]="false"
        [formControl]="orderForm.controls.buyerCode"
        [items]="catalogs.buyers$ | async"
        [itemSearch]="'search'"
        [itemValue]="'code'"
        [displayValue]="'code'"
        [itemText]="'code'"
      ></app-autocomplete>
    </div>
    @if (isImported) {
      <div class="w-4/12">
        <tui-input
          [formControl]="orderForm.controls.airWaybillNumber"
          tuiTextfieldSize="m"
          >AWB</tui-input
        >
      </div>
    }
  </div>
  <div class="flex gap-x-2 mb-4">
    <app-autocomplete
      label="Посредник"
      [labelOutside]="false"
      class="w-2/12"
      [formControl]="orderForm.controls.brokerJson.controls.id"
      [items]="sellers$ | async"
      [itemValue]="'id'"
      [itemText]="'name'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
    >
    </app-autocomplete>
    <tui-input
      class="w-2/12"
      [formControl]="orderForm.controls.invoiceNumber"
      tuiTextfieldSize="m"
      >Инвойс</tui-input
    >
    <div class="w-[140px]">
      <app-input-date
        [formControl]="orderForm.controls.invoiceDate"
        label="Дата инвойса"
        [labelOutside]="false"
      ></app-input-date>
    </div>
    <tui-input-number
      class="w-1/12"
      [precision]="2"
      [formControl]="orderForm.controls.invoiceCost"
      tuiTextfieldSize="m"
      >Сумма</tui-input-number
    >
    <app-autocomplete
      class="w-1/12"
      label="Валюта"
      [labelOutside]="false"
      [itemValue]="'letterCode'"
      [itemText]="'name'"
      [items]="CURRENCIES"
      [formControl]="orderForm.controls.invoiceCurrencyLetter"
    ></app-autocomplete>
    <div class="w-[140px] flex items-center">
      <tui-toggle
        [formControl]="orderForm.controls.prepayment"
        size="m"
        class="mx-2"
      ></tui-toggle>
      <span class="text-sm">Предоплата</span>
    </div>
  </div>
  <div>
    @for (file of attachmentsWithProcessDetails$ | async; track $index) {
      <div class="flex gap-x-2 bg-neutral-100 mb-2 rounded-xl p-2 items-center">
        <div class="font-bold">{{ $index + 1 }}</div>
        <div>{{ file.name }}</div>
        <div>{{ roundDecimal(file.length / (1024 * 1024)) }}Мб</div>
        <div class="mr-0 ml-auto flex gap-x-1">
          @if (!file.process) {
            <button
              appearance="secondary"
              (click)="handleInvoice$.next(file)"
              icon="tuiIconEye"
              tuiButton
              size="s"
            >
              Распознать
            </button>
          } @else {
            @if (file.process.status === InvoiceProcessStatus.PROCESSING) {
              <button
                appearance="secondary-destructive"
                [icon]="loader"
                [disabled]="true"
                tuiButton
                size="s"
              >
                <ng-template #loader>
                  <tui-loader
                    size="s"
                    [inheritColor]="true"
                    [showLoader]="true"
                    [style.height.px]="24"
                    [style.width.px]="24"
                  ></tui-loader>
                </ng-template>
                Обработка...
              </button>
            } @else if (
              file.process.status === InvoiceProcessStatus.COMPLETED
            ) {
              <button
                [showLoader]="
                  loadingDetails?.has(file.process.invoiceId ?? 0) ?? false
                "
                (click)="openInvoice$.next(file.process.invoiceId)"
                tuiButton
                size="s"
              >
                Просмотреть
              </button>
            } @else if (file.process.status === InvoiceProcessStatus.ERROR) {
              <button
                icon="tuiIconAlertTriangle"
                appearance="custom-danger"
                (click)="handleInvoice$.next(file)"
                tuiButton
                size="s"
              >
                Повторить
              </button>
            }
          }
          <button
            (click)="openFileInNewTab$.next(file.name)"
            size="s"
            tuiIconButton
            icon="tuiIconFileText"
          ></button>
        </div>
      </div>
    }
  </div>
  <div class="my-2">
    <app-files-input
      [accept]="
        [
          mimeTypes.APPLICATION_PDF,
          mimeTypes.IMAGE,
          mimeTypes.EXCEL,
          mimeTypes.EXCEL_OLD,
          mimeTypes.DOCX,
          mimeTypes.DOC
        ].join()
      "
      [formControl]="files"
    ></app-files-input>
  </div>

  <div class="flex gap-x-2">
    <button
      [disabled]="!canEdit"
      tuiButton
      size="m"
      (click)="saveChanges$.next({ close: false })"
    >
      Сохранить
    </button>
    <button
      appearance="secondary"
      [disabled]="!canEdit"
      tuiButton
      size="m"
      (click)="saveChanges$.next({ close: true })"
    >
      Сохранить и выйти
    </button>
    <button
      [disabled]="!(attachmentsWithProcessDetails$ | async)?.length"
      appearance="outline"
      tuiButton
      size="m"
      icon="tuiIconDownload"
      (click)="download$.next()"
    >
      Скачать архив
    </button>
    <button
      class="ml-auto mr-0"
      [disabled]="
        canRemove ? !(attachmentsWithProcessDetails$ | async)?.length : true
      "
      appearance="secondary-destructive"
      tuiButton
      icon="tuiIconTrash"
      size="m"
      (click)="delete$.next()"
    >
      Удалить архив
    </button>
  </div>
</div>
